module.exports = __webpack_public_path__ + "static/img/how-it-work-1.36d956c1.svg";